import React from "react";
import { Box, Divider, Skeleton, Typography } from "@mui/material";

interface InfoCardProps {
  title: string;
  value?: string | number | null;
  icon?: React.ReactNode;
  description?: string;
  styleProps?: any;
  onClick?: () => void;
  isLoading?: boolean;
}

const InfoCardComponent = (props: InfoCardProps) => {
  const {
    title,
    value,
    icon,
    description,
    styleProps,
    onClick,
    isLoading = false,
  } = props;

  const titleStyle = () => {
    return {
      fontFamily: "Inter",
      fontWeight: 700,
      fontStyle: "Bold",
      fontSize: "14px",
      leadingTrim: "NONE",
      lineHeight: "20px",
      letterSpacing: "0%",
    };
  };

  const valueStyle = () => {
    return {
      fontFamily: "Inter",
      fontWeight: 600,
      fontStyle: "Semi Bold",
      fontSize: "30px",
      leadingTrim: "NONE",
      lineHeight: "36px",
      letterSpacing: "0%",
    };
  };

  const descriptionStyle = () => {
    return {
      fontFamily: "Inter",
      fontWeight: 500,
      fontStyle: "Medium",
      fontSize: "11px",
      leadingTrim: "NONE",
      lineHeight: "15px",
      letterSpacing: "0%",
    };
  };

  return (
    <>
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          cursor: onClick ? "pointer" : "default",
          transition: "box-shadow 0.2s",
          "&:hover": onClick ? {
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          } : {},
          ...styleProps,
        }}
        onClick={onClick}
      >
        <Box sx={{ backgroundColor: "#f9fafc", padding: "15px", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
          <Typography sx={titleStyle}>{title}</Typography>
        </Box>
        <Divider variant={"fullWidth"} />
        <Box sx={{
          backgroundColor: "white",
          padding: "15px",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}>
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            {isLoading ? (
              <Skeleton variant="text" width={70} height={36} />
            ) : (
              <Typography sx={valueStyle}>{value}</Typography>
            )}
            {isLoading ? (
              <Skeleton variant="circular" width={28} height={28} />
            ) : (
              icon
            )}
          </Box>
          <Box>
            <Typography sx={descriptionStyle}>{description}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default InfoCardComponent;

